import { Box, darken, SxProps, Theme, Typography, useTheme } from "@mui/material";

interface Props {
  text: string;
  percent: number;
  sx?: SxProps<Theme>;
  trailingIcon?: React.ReactNode;
  onClick?: () => void;
}

export const Percentage: React.FC<Props> = ({ text, percent, sx, trailingIcon, onClick }) => {
  const theme = useTheme();
  const textColor = theme.palette.getContrastText(theme.palette.background.paper);

  return <Box
    onClick={onClick}
    sx={{
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      width: "100%",
      padding: "1.5em",
      borderRadius: "2em",
      backgroundColor: theme.palette.background.paper,
      ...sx,
    }}
  >
    <Typography
      fontSize={"5em"}
      fontWeight={"bold"}
      color={textColor}
      style={{ textOverflow: "ellipsis" }}
    >
      {text}
    </Typography>

    <div style={{ flex: 1 }} />

    <div style={{
      display: "flex",
      flexDirection: "row",
      width: "65em",
      alignItems: "center",
    }}>
      <div style={{
        backgroundColor: theme.palette.primary.main,
        height: "2em",
        borderTopLeftRadius: "1em",
        borderBottomLeftRadius: "1em",
        flex: percent,
      }} />
      <div style={{
        backgroundColor: darken(theme.palette.primary.contrastText, 0.3),
        height: "2em",
        borderTopRightRadius: "1em",
        borderBottomRightRadius: "1em",
        flex: Math.max((100 - percent), 0.1),
      }} />

      <div style={{ width: "5em" }} />

      <Typography
        fontSize={"5em"}
        fontWeight={"bold"}
        color={textColor}
        style={{ textOverflow: "ellipsis" }}
      >
        {(percent).toFixed(2).replace(".", ",") + "%"}
      </Typography>

    </div>

    {trailingIcon && <div style={{ width: "2em" }} />}
    {trailingIcon && trailingIcon}

    <div style={{ width: "2em" }} />
  </Box>;

};